
export function isMobile() {
    if (window.location !== window.parent.location ) {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    } else if(window.innerWidth >= 768) {
        return false
    }

    return true
}
